module.exports = __webpack_public_path__ + "img/7E5E57_AD9794_612D1D_C9997D-256px.133338b3.png";